import React, {useMemo} from "react";
import {Link} from "react-router-dom";
import {dateFormat, newsTime} from "../../units";

interface CommonLinkProps {
    link?: string,
    url?: string,
    path?: string,
    id: string,
    type?: number,
    [propName: string]: any
}

export const CommonLink: React.FC<CommonLinkProps> = (props) => {
    return <>
        {
            props.type === 0 ?
                <a href={props.link} className="new-item">{props.children}</a> :
                (
                    props.path && <Link className="new-item" to={props.path}>
                        {props.children}
                    </Link>
                )
        }
    </>
}

interface CommonListItemProps extends CommonLinkProps {
    coverUrl: string,
    date?: string,
}

export const CommonListItem: React.FC<CommonListItemProps> = (props) => {

    return <CommonLink {...props} >
        <div className="text">
            <h3>{props.title}</h3>
            {/*<p className="des">{ props.summary }</p>*/}
            <p className="date">{props.date || newsTime(props) }</p>
        </div>
        <div className="img-box">
            <div className="bg" style={{backgroundImage: `url(${props.coverUrl})`}}/>
        </div>
    </CommonLink>
}

interface CommonListsProps {
    lists: Array<CommonListItemProps>,
    onPageChange?: (page: number) => void,
    autoPage?: boolean,
    path: string
}

function pathReplace(path: string, id: string) {
    return path.replace(/@id/, id)
}

export const CommonLists: React.FC<CommonListsProps> = ({ autoPage = false, onPageChange = () => {}, ...props }) => {

    const lists = useMemo<Array<CommonListItemProps>>(() => {
        return props.lists.map(item => {

            for (let key in item) {

                if (item.hasOwnProperty(key)) {

                    if (/title/i.test(key)) {
                        item['title'] = item[key]
                        break;
                    }
                }
            }

            item.path = pathReplace(props.path, item.id)

            return item
        })

    }, [props.lists])

    return <div className="news-lists">
        {
            lists.map((item, index) => {
                return <React.Fragment key={index}>
                    <CommonListItem {...item} />
                </React.Fragment>
            })
        }
    </div>
}
